"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsToDocumentConverter = void 0;
/* eslint max-classes-per-file: ["error", 2] */
const lodash_1 = __importDefault(require("lodash"));
const utils_1 = require("../../utils");
const AJsonStruct_1 = require("./AJsonStruct");
const constants_1 = __importDefault(require("../../constants"));
const OP_TYPE_DEFAULTS = 'defaults';
const OP_TYPE_PAGE = 'pages';
const OP_TYPE_ATTRIBUTE = 'attributes';
const OP_TYPE_COMMENT = 'comment';
const PREFIX_REGA = new RegExp(`${constants_1.default.DOC_PREFIX_BASE}\\d+${constants_1.default.DOC_PREFIX_SEP}`, 'gi');
function replaceTextToolSubType(operation) {
    // TODO: figure out - maybe it should do converter? or maybe it is really old boolShit
    if (lodash_1.default.get(operation, 'properties.subType') === 'overlying') {
        lodash_1.default.set(operation, 'properties.subType', 'none');
    }
    return operation;
}
class OperationsToDocumentConverter {
    convert(operations, optionsBase = {}) {
        const { forEachOperation, templateIdGenerator, dpi, version, generateLayers } = optionsBase;
        let isTemplateChanged = false;
        const existedLinkId = [];
        // collect exist ids, find pages operations
        const { fieldIds, pagesOperation, operationsWithoutDuplicates } = operations.reduce((acc, op) => {
            const id = lodash_1.default.get(op, 'properties.template.id', false);
            if (id) {
                if (existedLinkId.includes(id)) {
                    this.removeDuplicateLinkId(op);
                }
                else {
                    existedLinkId.push(id);
                }
                acc.operationsWithoutDuplicates.push(op);
                acc.fieldIds.push(id);
                return acc;
            }
            acc.operationsWithoutDuplicates.push(op);
            if (lodash_1.default.get(op, 'properties.type', false) === OP_TYPE_PAGE) {
                return Object.assign(Object.assign({}, acc), { pagesOperation: op });
            }
            return acc;
        }, {
            fieldIds: [],
            pagesOperation: false,
            operationsWithoutDuplicates: [],
        });
        operations = operationsWithoutDuplicates;
        if (optionsBase.isSortFields) {
            operations = operations.sort((a, b) => {
                const isTemplate = a.properties.template && b.properties.template;
                if (!isTemplate)
                    return 0;
                const curOrder = a.properties.template.order || 0;
                const nextOrder = b.properties.template.order || 0;
                return curOrder - nextOrder;
            });
        }
        // define merge options
        const options = optionsBase.merge && pagesOperation ? this._extractMergeOptions(pagesOperation, optionsBase) : optionsBase;
        const aJsonParams = Object.assign(Object.assign(Object.assign(Object.assign({ fieldIds,
            generateLayers }, (templateIdGenerator ? { templateIdGenerator } : {})), (dpi ? { dpi } : {})), (version ? { version } : {})), { isAnonymizeDoc: !!optionsBase.isAnonymizeDocument });
        const docStruct = new AJsonStruct_1.AJsonStruct(aJsonParams);
        // process pages operation
        if (pagesOperation) {
            const pagesArray = this._extractPagesArray(pagesOperation, options);
            docStruct.addPages(pagesArray);
        }
        operations.forEach((operation) => {
            try {
                const opType = lodash_1.default.get(operation, 'properties.type');
                // skip "defaults" and "pages"
                if ([OP_TYPE_DEFAULTS, OP_TYPE_PAGE].includes(opType))
                    return;
                if (options.merge) {
                    const mergeShift = lodash_1.default.get(options, 'merge.pageShift', 0);
                    const mergePageCount = lodash_1.default.get(options, 'merge.pageCount', 0);
                    const operationPageId = operation.properties.pageId;
                    if (operationPageId < mergeShift || operationPageId >= mergeShift + mergePageCount)
                        return;
                    operation.properties.pageId -= mergeShift;
                }
                // apply regular operation transforms
                operation = this._transformOperation(operation);
                // apply passed operation transforms
                if (typeof forEachOperation === 'function') {
                    const fnRes = forEachOperation(operation);
                    if (typeof fnRes !== 'undefined') {
                        if (!fnRes)
                            return;
                        operation = fnRes;
                    }
                }
                const operationType = lodash_1.default.get(operation, 'properties.type', false);
                // attributes
                const isAttributeOperation = operationType === OP_TYPE_ATTRIBUTE;
                if (isAttributeOperation) {
                    const { pageShift, pageCount } = options.merge || {};
                    const attrOp = operation;
                    if (pageShift && pageCount) {
                        attrOp.properties.content.pagesRange = utils_1.unshiftRange(attrOp.properties.content.pagesRange, {
                            pageShift,
                            pageCount,
                        });
                    }
                    const operationAttributeProps = attrOp.properties;
                    return docStruct.addAttribute(operationAttributeProps);
                }
                // comment
                const isCommentOperation = operationType === OP_TYPE_COMMENT;
                if (isCommentOperation) {
                    return docStruct.addComment(operation.properties);
                }
                const isToolOperation = lodash_1.default.get(operation, 'properties.group') === 'tools';
                const contentSection = isToolOperation && lodash_1.default.get(operation, 'properties.content', false);
                const templateSection = isToolOperation && lodash_1.default.get(operation, 'properties.template', false);
                const isContentOperation = !lodash_1.default.isEmpty(contentSection);
                const isTemplateOperation = !lodash_1.default.isEmpty(templateSection);
                // template
                if (isTemplateOperation) {
                    if (options.merge) {
                        operation.properties = this.removePrefixField(operation.properties);
                    }
                    const { isTemplateItemChanged } = docStruct.addTemplate(operation.properties);
                    if (isTemplateItemChanged)
                        isTemplateChanged = true;
                }
                // content
                if (isContentOperation) {
                    // const operationProperties = options.merge
                    //   ? this.removePrefixContent(operation.properties as IOperationPropertiesContent)
                    //   : (operation.properties as IOperationPropertiesContent);
                    // docStruct.addContent(operationProperties);
                    docStruct.addContent(operation.properties);
                }
            }
            catch (e) {
                docStruct.addWarning(e);
            }
        });
        return Object.assign({ document: docStruct.toJson(), isTemplateChanged }, (options.isAnonymizeDocument ? { anonymizedDocument: docStruct.getAnonymized() } : {}));
    }
    _transformOperation(operation) {
        const transformChain = [replaceTextToolSubType];
        transformChain.forEach((fn) => {
            if (operation)
                operation = fn(operation);
        });
        return operation;
    }
    _extractMergeOptions(pagesOperation, options = {}) {
        const mergeDocIndex = lodash_1.default.get(options, 'merge.documentIndex', 0);
        const { pageShift, pageCount } = lodash_1.default.get(pagesOperation, 'properties.documents', []).reduce((acc, item, index) => {
            if (index < mergeDocIndex)
                acc.pageShift += +item.pagesCount;
            if (index === mergeDocIndex)
                acc.pageCount = item.pagesCount;
            return acc;
        }, {
            pageShift: 0,
            pageCount: 0,
        });
        return Object.assign(Object.assign({}, options), { merge: {
                documentIndex: mergeDocIndex,
                pageShift,
                pageCount,
            } });
    }
    _extractPagesArray(operation, options = {}) {
        if (!options.merge)
            return lodash_1.default.get(operation, 'properties.pages', []);
        const documentIndex = lodash_1.default.get(options, 'merge.documentIndex', false);
        if (documentIndex === false)
            return lodash_1.default.get(operation, 'properties.pages', []);
        const documentParams = lodash_1.default.get(operation, `properties.documents[${documentIndex}]`, false);
        if (documentParams === false)
            return lodash_1.default.get(operation, 'properties.pages', []);
        const allPages = lodash_1.default.get(operation, 'properties.pages', []);
        const mergeShift = lodash_1.default.get(options, 'merge.pageShift', 0);
        return allPages
            .slice(mergeShift, mergeShift + documentParams.pagesCount)
            .map((item, index) => (Object.assign(Object.assign({}, item), { source: index })));
    }
    removePrefix(str) {
        return str.replace(PREFIX_REGA, '');
    }
    removePrefixField(operationProperties) {
        if (!operationProperties.template.name)
            throw new Error(`Expected field name`);
        if (!operationProperties.template.id)
            throw new Error(`Expected field id attr (name: ${operationProperties.template.name})`);
        const result = Object.assign(Object.assign({}, operationProperties), { template: Object.assign(Object.assign({}, operationProperties.template), { id: this.removePrefix(operationProperties.template.id.toString()), name: this.removePrefix(operationProperties.template.name) }) });
        if (typeof result.template.formula === 'string' && result.template.formula) {
            result.template.formula = this.removePrefix(result.template.formula);
        }
        if (result.template.dependency) {
            if ('name' in result.template.dependency)
                result.template.dependency.name = this.removePrefix(result.template.dependency.name);
            if ('clauses' in result.template.dependency)
                result.template.dependency.clauses = result.template.dependency.clauses.map((dependency) => (Object.assign(Object.assign({}, dependency), { name: dependency.name ? this.removePrefix(dependency.name) : dependency.name })));
        }
        return result;
    }
    removeDuplicateLinkId(operation) {
        const linkId = lodash_1.default.get(operation, 'properties.content.linkId');
        delete operation.properties.template.id;
        if (linkId) {
            delete operation.properties.content.linkId;
        }
    }
}
exports.OperationsToDocumentConverter = OperationsToDocumentConverter;
//# sourceMappingURL=index.js.map